import { ApiError } from "@/core/api/apiTypes";
import { EmptyState } from "@/shared/components/ui/EmptyState";
import { ErrorState } from "@/shared/components/ui/ErrorState";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";

export function FormUnavailable({ error, onRetry }: { error?: Error | null; onRetry: () => void }) {
  const { goToHome } = useAppNavigation();
  if (error && !(error instanceof ApiError && (error.Status === 404 || error.Status === 403))) {
    return <ErrorState message={error.message} onRetry={onRetry} />;
  }
  return <EmptyState title="Form unavailable" message="This form may have been deleted, or you may no longer have access to it." action={{ label: "Back to Home", onClick: goToHome }} />;
}
